import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
export default function Header() {
  const { user, profile, signOut, canManageUsers, canAccessStudio } = useAuth();
  const navigate = useNavigate();
  return <Navbar bg="dark" variant="dark" expand="lg"><Container>
    <Navbar.Brand as={Link} to="/admin/dashboard"><img src="/logo.png" alt="Hestia" height="30" className="me-2" />Admin</Navbar.Brand>
    <Navbar.Toggle aria-controls="admin-navigation" />
    <Navbar.Collapse id="admin-navigation"><Nav className="ms-auto align-items-lg-center gap-lg-2">
      {user ? <>
        {canAccessStudio && <><Nav.Link as={Link} to="/admin/dashboard">Dashboard</Nav.Link>
          <Nav.Link as={Link} to="/dev/door-leaf">Door Studio</Nav.Link>
          <Nav.Link as={Link} to="/configurator">Configurator</Nav.Link>
          <Nav.Link as={Link} to="/admin/pricing">Pricing</Nav.Link></>}
        {canManageUsers && <Nav.Link as={Link} to="/admin/users">Users &amp; access</Nav.Link>}
        <Nav.Link as={Link} to="/admin/profile">Profile</Nav.Link>
        <Navbar.Text>{profile?.full_name || user.email}</Navbar.Text>
        <Button variant="outline-light" size="sm" onClick={async () => { const { error } = await signOut(); if (!error) navigate('/admin/login'); }}>Sign out</Button>
      </> : <Nav.Link as={Link} to="/admin/login">Admin sign in</Nav.Link>}
    </Nav></Navbar.Collapse>
  </Container></Navbar>;
}
